module.exports = __webpack_public_path__ + "static/images/event/dialog-error.png";